import React from 'react';
import ReactDOM from 'react-dom';
import Oauth from './routing/Oauth';

ReactDOM.render(<Oauth />, document.getElementById('root'));

